export const GrowthBook연결 = {
  COOKIE: "gb_connection_id",
};
